<div class="button-container">
    <div>
        <button class="cancel-btn" (click)="handleCancel()">
            <img src="assets/24x24/arrow-left-circle.svg" alt="">
            <span>Cancel</span>
        </button>
    </div>
    <div class="step-nav-buttons">
        <app-button (click)="goToPrevious()" [disabled]="currentStep === 0 || isLoading" [type]="'primary'"
            [theme]="'tertiary'" [size]="'medium'">Previous</app-button>
        <app-button (click)="goToNext()" [disabled]="currentStep === steps.length - 1 || isLoading" [theme]="'primary'"
            [size]="'medium'">Next</app-button>
    </div>
</div>
<div class="step-progress-container">
    <ng-container *ngFor="let step of steps; let i = index">
        <div class="step-wrapper">
            <div class="step-circle" [ngClass]="{
             'completed': isCompleted(i),
             'active': isActive(i),
             'upcoming': isUpcoming(i)
           }">
                <div class="inner-circle" *ngIf="isActive(i)"></div>
                <div class="inner-circle" *ngIf="isCompleted(i)">✓</div>
            </div>

            <div class="step-label" [ngClass]="{
                'completed': isCompleted(i),
                'active': isActive(i),
                'upcoming': isUpcoming(i)
            }">{{ step }}</div>
        </div>

        <div *ngIf="i < steps.length - 1" class="step-connector" [ngClass]="{ 'completed': isConnectorCompleted(i) }">
        </div>
    </ng-container>
</div>